// Every business date in this app is an Indian date. Left to the browser, the
// date came from whatever timezone the operator's PC happened to be set to - a
// machine on Bangkok/Tokyo/Sydney time rolls over to tomorrow while it is still
// today in India, which is how POs and invoices were being saved a day ahead.
//
// These helpers pin the calculation to Asia/Kolkata, so the same instant gives
// the same date on every machine.
//
// `en-CA` is used deliberately: it formats as YYYY-MM-DD, which is exactly what
// <input type="date"> expects and what the API is sent.

const IST = "Asia/Kolkata";

const formatter = (locale, options) =>
  new Intl.DateTimeFormat(locale, { timeZone: IST, ...options });

// Today's date in India, as YYYY-MM-DD. Use this for date-input defaults and
// for the `max` that stops a future date being picked.
export const istToday = () => formatter("en-CA").format(new Date());

// A stored value rendered for an <input type="date">. Returns "" for a missing
// or unparseable value rather than silently falling back to today.
export const istDateInput = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "" : formatter("en-CA").format(parsed);
};

// A stored value rendered for display, as DD-MM-YYYY.
export const istDateDisplay = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return formatter("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
    .format(parsed)
    .replace(/\//g, "-");
};

// True when the value falls after today in India.
export const isFutureIstDate = (value) => {
  if (!value) return false;
  const asDate = istDateInput(value);
  return Boolean(asDate) && asDate > istToday();
};
